import { createFileRoute } from "@tanstack/react-router";
import { FinnLeverandoerPage } from "@/features/bestillinger/pages";

export const Route = createFileRoute("/_app/bestilling/ny/finn-leverandoer/")({
  component: FinnLeverandoerPage,
  head: () => ({
    meta: [
      {
        title: "Finn leverandør | Norgespris for Fjernvarme",
      },
    ],
  }),
});
